import { Route, Navigate } from "react-router-dom";
import { HomePage } from "../components/WebUi/Pages/HomeV3/HomePage";
import { AddStudentPage } from "../components/WebUi/Pages/AddStudent/AddStudentPage";
import { useAuthStudent } from "../components/context/StudentLoginContext/StudentAuthContext";
import LogoLoader from "../components/common/LogoLoader";

const AddStudentGuard = ({ children }) => {
  const { student, loading } = useAuthStudent();

  if (loading) {
    return <LogoLoader />;
  }

  const currentUser = student?.student;

  // Not logged in or not a student → redirect to home
  if (!currentUser || currentUser?.role_id !== 5) {
    return <Navigate to="/" replace />;
  }

  // Must NOT be subscribed
  const isSubscribed =
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed;
  if (isSubscribed) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const NewHomePageRoutes = () => {
  return (
    <>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/add-student"
        element={
          <AddStudentGuard>
            <AddStudentPage />
          </AddStudentGuard>
        }
      />
    </>
  );
};

export default NewHomePageRoutes;
